
const getFormatCurrency = (mount, currency) => {
    return currency + mount.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
}

const getCurrency = (mount) => {
    return mount.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
}

// Convierte a numero admitiendo importes con separador de miles ("1,500.00").
// Devuelve fallback cuando el valor no es numerico.
const toNumber = (value, fallback = null) => {
    if (value === null || value === undefined || value === '') {
        return fallback;
    }
    const normalized = typeof value === 'string' ? value.replace(/[,\s]/g, '') : value;
    const number = parseFloat(normalized);
    return Number.isFinite(number) ? number : fallback;
}

// Redondea a dos decimales evitando el error de representacion binaria.
const roundMoney = (value) => {
    const number = toNumber(value, 0);
    return parseFloat(number.toFixed(2));
}

// Compara importes con tolerancia para no depender de la igualdad exacta de los flotantes.
const isEqualMoney = (a, b, tolerance = 0.01) => {
    const valueA = toNumber(a);
    const valueB = toNumber(b);
    if (valueA === null || valueB === null) {
        return false;
    }
    return Math.abs(valueA - valueB) < tolerance;
}

export { getFormatCurrency, getCurrency, toNumber, roundMoney, isEqualMoney }